export default {"src":"/static/spa/fresh-spa/_next/static/media/icon-free-shipping.7e742875.svg","height":123,"width":141,"blurWidth":0,"blurHeight":0};